import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

/* Layout */
export const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #000, #0f172a, #000);
  color: #fff;
`;

export const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const HeaderTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
`;

export const HeaderSub = styled.p`
  font-size: 0.875rem;
  opacity: 0.7;
  margin: 4px 0 0 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (min-width: 1024px) {
    grid-template-columns: 2fr 1fr;
  }
`;

export const Card = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 16px;
  padding: 24px;
`;

export const CardFull = styled(Card)`
  @media (min-width: 1024px) {
    grid-column: 1 / -1;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const CardTitle = styled.h2`
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
`;

/* Form elements */
export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const TextareaSmall = styled(Textarea)`
  min-height: 80px;
  font-size: 0.875rem;
  margin-top: 12px;
`;

/* Buttons */
export const Btn = styled.button`
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const BtnPrimary = styled(Btn)`
  background: linear-gradient(to right, rgba(6, 182, 212, 0.3), rgba(14, 165, 233, 0.3));
  border: 1px solid rgba(6, 182, 212, 0.4);
  color: #fff;
`;

export const BtnSuccess = styled(Btn)`
  background: linear-gradient(to right, rgba(34, 197, 94, 0.3), rgba(16, 185, 129, 0.3));
  border: 1px solid rgba(34, 197, 94, 0.4);
  color: #fff;
`;

export const BtnDanger = styled(Btn)`
  background: linear-gradient(to right, rgba(239, 68, 68, 0.3), rgba(244, 63, 94, 0.3));
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #fff;
`;

export const BtnGhost = styled(Btn)`
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
`;

export const BtnSmall = styled(Btn)`
  padding: 6px 12px;
  font-size: 12px;
`;

/* Hash section */
export const HashBox = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 12px;
`;

export const HashLabel = styled.p`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.6;
  margin: 0 0 4px 0;
`;

export const HashRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HashInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 12px;
  color: #67e8f9;
`;

/* Signers */
export const SignerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 8px;
`;

export const SignerAddRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

export const SignerSearchWrap = styled.div`
  position: relative;
  flex: 1;
`;

export const SignerSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2367e8f9' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  &:focus {
    outline: none;
    border-color: rgba(6, 182, 212, 0.5);
  }
`;

export const SignerDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #0f172a;
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
`;

export const SignerDropdownItem = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: #fff;
  transition: background 0.15s;
  &:hover {
    background: rgba(6, 182, 212, 0.1);
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const SignerDropdownName = styled.div`
  font-weight: 500;
  font-size: 14px;
`;

export const SignerDropdownAddress = styled.div`
  font-size: 12px;
  color: #67e8f9;
  margin-top: 2px;
  word-break: break-all;
`;

export const SignerRemove = styled.button`
  background: none;
  border: none;
  color: #f87171;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
`;

/* Signer status */
export const StatusBox = styled.div`
  margin-top: 24px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 12px;
`;

export const StatusItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 999px;
  overflow: hidden;
  margin: 8px 0 12px 0;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(to right, #06b6d4, #0ea5e9);
  border-radius: 999px;
  transition: width 0.2s;
`;

/* Documents */
export const DropZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
  border: 2px dashed rgba(6, 182, 212, 0.4);
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.3);
  text-align: center;
  margin-bottom: 24px;
`;

export const DocItem = styled.div`
  padding: 12px 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  border: 1px solid ${({ signed }) => (signed ? 'rgba(255,255,255,0.1)' : 'rgba(248,113,113,0.4)')};
  background: ${({ signed }) => (signed ? 'rgba(0,0,0,0.4)' : 'rgba(239,68,68,0.05)')};
`;

export const DocItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DocSignBtn = styled.button`
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 12px;
  background: rgba(6, 182, 212, 0.2);
  color: #fff;
  border: none;
  cursor: pointer;
`;

export const SignaturePreview = styled.div`
  margin-top: 12px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
`;

/* Modals */
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

export const ModalBox = styled.div`
  background: #0f172a;
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 16px;
  padding: 24px;
  width: ${({ width }) => width || '520px'};
  animation: ${fadeIn} 0.2s ease;
`;

export const ModalTitle = styled.h3`
  font-weight: 500;
  margin: 0 0 12px 0;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const ColorInput = styled.input`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  padding: 0;
`;

export const Canvas = styled.canvas`
  display: block;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const OTPInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.5em;
  font-size: 18px;
  margin-bottom: 12px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const SuccessIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
  font-size: 1.5rem;
  color: #86efac;
`;

/* Safebox Manager layout */
export const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #000, #0f172a, #000);
  color: #fff;
`;

export const InnerWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px;
`;

export const StickyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  position: sticky;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  z-index: 10;
  padding: 16px;
  border-radius: 12px;
`;

export const HeaderContent = styled.div`
  display: flex;
  gap: 8px;
`;

export const GridLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const MetadataCard = styled(Card)`
  @media (min-width: 1024px) {
    grid-column: span 2;
  }
`;

export const SignersCard = styled(Card)``;

export const DocumentsCard = styled(Card)`
  @media (min-width: 1024px) {
    grid-column: 1 / -1;
  }
`;

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SignerHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const ChatBtn = styled(BtnGhost)`
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;


export const ChatTooltip = styled.div`
  pointer-events: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  width: 224px;
  padding: 12px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s;
`;

export const ChatBtnWrap = styled.div`
  position: relative;
  &:hover ${ChatTooltip} {
    opacity: 1;
  }
`;

export const SignerInputRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

export const SignerItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 8px;
`;

export const SignerRemoveBtn = styled.button`
  background: none;
  border: none;
  color: #f87171;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
`;

export const ApproveSignersBtn = styled(BtnPrimary)`
  width: 100%;
  margin-top: 16px;
  padding: 8px 16px;
  &:disabled {
    opacity: 0.4;
  }
`;

export const HashInputReadonly = styled.input`
  flex: 1;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 12px;
  color: #67e8f9;
`;

export const HashActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const LinkBtn = styled.a`
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: inherit;
  text-decoration: none;
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const StatusLabel = styled.p`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.6;
  margin: 0 0 8px 0;
`;

export const StatusProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  opacity: 0.6;
  margin-bottom: 4px;
`;

export const OTPProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 8px;
`;

export const OTPProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(to right, #06b6d4, #0ea5e9);
  border-radius: 999px;
  transition: width 0.2s;
`;

export const StatusEmpty = styled.p`
  font-size: 12px;
  opacity: 0.6;
  margin: 0;
`;

export const NotificationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const MutedText = styled.span`
  opacity: 0.5;
`;

export const ColorLabel = styled.span`
  font-size: 12px;
  opacity: 0.7;
`;

export const ColorValue = styled.span`
  font-size: 12px;
  color: #67e8f9;
`;

export const ColorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

export const PdfPreviewLayout = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px;
  width: 90vw;
  height: 90vh;
  border-radius: 16px;
  background: #0f172a;
  border: 1px solid rgba(6, 182, 212, 0.2);
`;

export const PdfPreviewMain = styled.div`
  flex: 1;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

export const PdfPreviewSidebar = styled.div`
  width: 256px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PlacedSigWrapper = styled.div`
  position: absolute;
  z-index: 20;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: box-shadow 0.2s, border-color 0.2s;
  ${({ $selected }) =>
    $selected
      ? `
    border: 2px solid rgba(6, 182, 212, 0.8);
    box-shadow: 0 0 12px rgba(6, 182, 212, 0.4);
  `
      : `
    border: 2px solid transparent;
    &:hover {
      border-color: rgba(6, 182, 212, 0.4);
    }
  `}
`;

export const PlacedSig = styled.img`
  display: block;
  pointer-events: none;
  opacity: 0.9;
`;

export const DraggableSig = styled.img`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 30;
  max-height: 80px;
  cursor: copy;
  border: 1px solid rgba(6, 182, 212, 0.4);
  background: rgba(0, 0, 0, 0.2);
`;

export const SizeLabel = styled.p`
  font-size: 12px;
  opacity: 0.6;
  margin: 0 0 4px 0;
`;

export const RangeInput = styled.input`
  width: 100%;
`;

export const PageNav = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
`;

export const ModalBoxNarrow = styled(ModalBox)`
  width: 420px;
`;

export const SuccessModalBox = styled(ModalBox)`
  width: 420px;
  text-align: center;
  border-color: rgba(34, 197, 94, 0.3);
`;

export const SuccessIconWrap = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
  font-size: 1.5rem;
  color: #86efac;
`;

export const DocItemWrap = styled(DocItem)``;

export const DocItemInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DocName = styled.span`
  font-size: 14px;
`;

export const SigPreviewWrap = styled(SignaturePreview)`
  margin-top: 12px;
`;

export const SigPreviewLabel = styled.p`
  font-size: 11px;
  opacity: 0.7;
  margin: 0 0 8px 0;
`;

export const SigPreviewImg = styled.img`
  max-height: 96px;
`;

export const DropZoneLabel = styled.label`
  margin-top: 8px;
  padding: 8px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 14px;
  cursor: pointer;
`;
